import React from "react";
import { react, nextjs, typescript, tailwind } from "../../assets";
import "./skills.css";

const Frontend = () => {
  return (
    <div className="frontend_section">
      <h1 className="tech__heading">Frontend</h1>
      <div className="tech__section">
        <div>
          <img src={typescript} alt="typescript" className="tech__logo" />
          <p>TypeScript</p>
        </div>
        <div>
          <img src={react} alt="react" className="tech__logo" />
          <p>React</p>
        </div>

        <div>
          <img src={nextjs} alt="nextjs" className="tech__logo" />
          <p>NextJs</p>
        </div>

        <div>
          <img src={tailwind} alt="tailwind" className="tech__logo" />
          <p>TailwindCSS</p>
        </div>
      </div>
    </div>
  );
};

export default Frontend;
